import styled from 'styled-components';

import { Button } from '@notino/react-styleguide';

export const StyledButton = styled(Button)`
  padding: 0 3rem;
`;
